<template>
<div id="wishForm">
  <div class="Lightbox">
    <div
      v-if="showOverlay"
      @click="close"
      class="LightboxOverlay"></div>
    <div class="LightboxWrap">
      <div class="Content">
        <h2>我要許願</h2>
        <div
          class="close"
          @click="close"></div>
        <div class="formWrapper">
          <form
            action=""
            @submit.prevent="submit()">
            <div class="inputWrapper"><label for="">姓名</label><input type="text" name="name" placeholder="請輸入聯絡人姓名"></div>
            <div class="inputWrapper"><label for="">電話</label><input type="tel" name="tel" placeholder="請輸入聯絡人電話" @blur="tel" onkeyup="value=value.replace(/[^\d]/g,'')" maxlength="10" minlength="9" /></div>
            <div class="inputWrapper"><label for="">E-mail</label><input type="email" name="email" placeholder="請輸入聯絡人E-mail" @blur="email"></div>
            <div class="inputWrapper"><label for="">許願清單 <span>*必填</span></label><textarea name="iwish" id="" placeholder="請輸入內容" @keyup="allowSend($event.target.value)" required></textarea></div>
            <hr>
            <div class="inputWrapper"><button type="submit" :class="{'disabled': allowForm == false}">送出</button></div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "wishForm",
  data() {
    return {
      allowForm: false,
      formObj: {
        name: '',
        phone: '',
        email: '',
        content: ''
      },
      formSend: false,
      emailCHK: true,
      telCHK: true
    }
  },
  props: {
    showOverlay: {
      type: Boolean,
      default: true
    },
    formShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    tel() {
      let telLen = document.querySelector('[name="tel"]').value.length
      if (telLen == 0) {
        this.telCHK = true
        return
      }
      if (telLen < 9 || telLen > 10) {
        this.$emit("alertTips", "請輸入有效電話號碼");
        this.telCHK = false
      }else{
        this.telCHK = true
      }
    },
    email() {
      let email = document.querySelector('[name="email"]').value
      if (email.length == 0) {
        this.emailCHK = true
        return
      }
      if (email.indexOf('@') == -1) {
        this.$emit("alertTips", "請輸入有效Email");
        this.emailCHK = false
      }else{
        this.emailCHK = true
      }
    },
    close() {
      this.$emit("closeBuyItem");
    },
    allowSend(val) {
      if (val != '') {
        this.allowForm = true
      } else {
        this.allowForm = false
      }
    },
    submit() {
      const name = document.querySelector("input[name='name']").value
      const phone = document.querySelector("input[name='tel']").value
      const email = document.querySelector("input[name='email']").value
      const content = document.querySelector("textarea[name='iwish']").value

      this.formObj.name = name;
      this.formObj.phone = phone;
      this.formObj.email = email;
      this.formObj.content = content;

      if (content !== '' && this.emailCHK && this.telCHK) {
        this.axios.post('misc/sendMail', this.formObj).then(res => {
          const data = res.data;
          if (data.response.status == 'OK') {
            this.formSend = true;
            this.$emit("alertTips", "Success!");
            this.formSend = false;
          } else if (data.response.status == 'ERROR') {
            this.$emit("alertTips", "操作太頻繁，請五分鐘後重試");
          }
          this.$emit("closeBuyItem");
        })
      } else {
        if (!this.emailCHK) {
          this.$emit("alertTips", "請輸入有效Email");
          return false
        }
        if (!this.telCHK) {
          this.$emit("alertTips", "請輸入有效電話號碼");
          return false
        }
        if (content !== '') {
          this.$emit("alertTips", "必填欄位要填!");
          return false
        }
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import "../../style/icon.scss";

::placeholder {
  color: #adadad;
  opacity: 1;
}

:-ms-input-placeholder {
  color: #adadad;
}

::-ms-input-placeholder {
  color: #adadad;
}

.LightboxWrap {
  width: 50%;
  max-width: 460px;

  @media(max-width:768px) {
    position: fixed;
    bottom: 0;
    width: 100%;
    margin: 0;
    max-width: none;
    border-radius: 0;
  }

  .Content {
    position: relative;

    h2 {
      text-align: center;
      border-bottom: 1px solid #e0e0e0;
      padding: 20px 0 10px;
      font-size: 1.125rem;
      margin-bottom: 10px;

      @media(max-width:768px) {
        padding: 10px 0;

      }
    }

    .close {
      width: 45px;
      height: 45px;
      position: absolute;
      top: 10px;
      right: 0;

      @media(max-width:768px) {
        top: 0
      }
    }

    .formWrapper {
      margin: 20px auto;

      @media(max-width:768px) {
        margin: 0 auto;
      }

      hr {
        display: none;
        border-top: 1px solid #e0e0e0;

        @media(max-width:768px) {
          display: block;
          margin: 0;
        }
      }

      .inputWrapper {
        padding: 10px 20px;

        @media(max-width:768px) {
          padding: 10px 25px;
        }

        label {
          display: block;
          color: #3c3c3c;
          font-size: .875rem;

          span {
            color: #f34f59
          }
        }

        input,
        textarea {
          width: 100%;
          box-sizing: border-box;
          padding: 9px 15px;
          background-color: #f8f9f9;
          border: none;
          border-radius: 10px;
          font-size: 1rem;
        }

        textarea {
          resize: none;
          min-height: 120px;
        }

        button {
          color: #fff;
          font-size: 1rem;
          width: 100%;
          padding: 10px 0;
          border-radius: 10px;
          text-align: center;
          background-color: #f34f59;

          &.disabled {
            background-color: #e0e0e0;
            cursor: not-allowed;
          }
        }

      }
    }
  }
}
</style>
